import { useCallback, useEffect, useState } from "react";

/**
 * Hook to get the current window size, and update the state when the window size changes.
 */
const useWindowSize = () => {
  const [state, setState] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  const orientation: () => "LANDSCAPE" | "PORTRAIT" = useCallback(
    () => (state.width > state.height ? "LANDSCAPE" : "PORTRAIT"),
    [state.width, state.height],
  );

  useEffect(() => {
    function handleResize() {
      setState({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return {
    ...state,
    isMobile: state.width < 768,
    orientation: orientation(),
  };
};
export { useWindowSize };
